import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import * as ProposerName from './columns/ProposerName';
import * as ProposerCompany from './columns/ProposerCompany';
import * as ProposerDbeMwbe from './columns/ProposerDbeMwbe';
import * as ProposerEmail from './columns/ProposerEmail';
import * as ProposerPhone from './columns/ProposerPhone';
import { Css, ITheme, RowRole } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import { ISolicitationProposer } from '../../../domain/models/ISolicitationProposer';

interface ISolicitationListRowProps {
	proposer: ISolicitationProposer;
	isFirst?: boolean;
}

export const StyledSolicitationRow = styled(RowRole, {
	shouldForwardProp: (props) => isPropValid(props),
})<{ isFirst?: boolean }, ITheme>`
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	padding: ${Css.pxToRem(16)} 0 ${Css.pxToRem(18)};
	border-bottom: 1px solid ${Color.Neutral2};
	height: fit-content;

	${({ isFirst }) => isFirst && `padding-top: ${Css.pxToRem(24)};`}

	:last-of-type {
		border-bottom: none;
	}
`;

export function SolicitationProposersListRow({
	proposer,
	isFirst,
}: ISolicitationListRowProps) {
	const {
		first_name: firstName,
		last_name: lastName,
		company,
		email,
		phone,
		mwbe_dbe: mwbeDbe,
	} = proposer;
	return (
		<StyledSolicitationRow isFirst={isFirst}>
			<ProposerName.Cell
				name={`${firstName} ${lastName}`}
				aria-label={`Proposer's name: ${firstName} ${lastName}`}
			/>

			<ProposerCompany.Cell
				company={company}
				aria-label={`Proposer's company: ${company}`}
			/>

			<ProposerDbeMwbe.Cell
				value={!!mwbeDbe}
				aria-label={`Proposer's DBE/MWBE: ${mwbeDbe}`}
			/>

			<ProposerEmail.Cell
				email={email}
				aria-label={`Proposer's Email: ${email}`}
			/>

			<ProposerPhone.Cell
				phone={phone}
				aria-label={`Proposer's Phone: ${phone}`}
			/>
		</StyledSolicitationRow>
	);
}
